import I18n from 'i18n-js'
import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { Page } from '../'
import { appsStyleSelected } from '../../helpers/app'
import { LiteralsService } from '../../services'
import StyledArticle, { SimpleMessagePageGlobalStyle } from './styles'

const SUPPORTED_LANGUAGES = ['ca', 'en', 'es', 'fr', 'it']
const DEFAULT_LANGUAGE = 'en'

interface SimpleMessagePageProps {
  messageKey: string
}

const SimpleMessagePage: React.FC<SimpleMessagePageProps> = ({ messageKey }) => {
  const { locale } = useParams<{ locale?: string }>()
  const activeLocale = locale && SUPPORTED_LANGUAGES.includes(locale) ? locale : DEFAULT_LANGUAGE

  useEffect(() => {
    LiteralsService.setLanguage(activeLocale)
  }, [activeLocale])

  return (
    <Page className={ `simple-message ${appsStyleSelected?.style ?? ''}` }>
      <SimpleMessagePageGlobalStyle />
      <StyledArticle>
        <div className="text-container">
          <div className="title" lang={ activeLocale }>
            { String(I18n.t(messageKey, { locale: activeLocale })).toUpperCase() }
          </div>
        </div>
      </StyledArticle>
    </Page>
  )
}

export default SimpleMessagePage
